/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from "@rails/ujs";
import "trix";
import "@rails/actiontext";
import Turbolinks from "turbolinks";
import "../controllers";

import initDelegateSearch from "./delegateSearch";
import initTimeSlotForm from "./timeSlotForm";
import "./clipBoards";

import "./app_admin/app_meetings";

Rails.start();
Turbolinks.start();

// Handles filename and image preview for the hub event profile logo/banner upload (hub/shared/_file_upload.html.erb).
function initFileUploadPreviews() {
  document.querySelectorAll(".file-upload__input").forEach((input) => {
    input.addEventListener("change", () => {
      var container = input.closest(".file-upload");
      if (!container || input.files.length === 0) return;

      var filenameSpan = container.querySelector(".file-upload__filename");
      if (filenameSpan) {
        filenameSpan.textContent = input.files[0].name;
      }

      if (input.files[0].type.startsWith("image/")) {
        const previewImg = container.querySelector(".file-upload__preview-img");
        const placeholder = container.querySelector(
          ".file-upload__preview-placeholder",
        );
        if (previewImg) {
          const reader = new FileReader();
          reader.onload = (e) => {
            previewImg.src = e.target.result;
            previewImg.style.display = "";
            if (placeholder) placeholder.style.display = "none";
          };
          reader.readAsDataURL(input.files[0]);
        }
      }
    });
  });
}

document.addEventListener("turbolinks:load", () => {
  initFileUploadPreviews();

  if (document.querySelector("[data-delegate-table]")) {
    initDelegateSearch();
  }
  if (
    document.querySelector("#time_slot_workshop_attributes_participant_count")
  ) {
    initTimeSlotForm();
  }

  // Checks for anchors on links and highlights if there some
  if (window.location.hash) {
    var row = document.querySelector(window.location.hash);
    if (row) {
      row.classList.add("anchor-highlight");
      setTimeout(() => {
        row.classList.remove("anchor-highlight");
      }, 2000); // Highlight for 2 seconds
    }
  }
});
